// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3g3zu","content":"styles_content__1WH7g","row":"styles_row__N74aC","footer":"styles_footer__1t_qw","phraseLength":"styles_phraseLength__lWqzS"};